<h1 mat-dialog-title>Dialog Title</h1>
<div mat-dialog-content>Dialog is opened</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
</div>
